import roleButtonKeyboardControl from '../../../../../_shared/js/utils/roleButtonKeyboardControl';

/**
 * Custom převedení multiselectu do podoby dropdownu s checkboxlisty nebo radiolistem (pro klasický select)
 * Stačí přidat na select atribut data-multiselect
 */

// Funkce pro odeslání formáře - voláme po kliknutí na odesílací tlačítko v dropdownu
const submitSearchForm = (form) => {
	if (form) {
		form.submit();
	}
};

// Funkce pro vytvoření prvku, který pak umístíme do DOM
const newEl = (tag, attrs) => {
	let e = document.createElement(tag);
	if (attrs !== undefined)
		Object.keys(attrs).forEach((k) => {
			if (k === 'class') {
				Array.isArray(attrs[k])
					? attrs[k].forEach((o) => (o !== '' ? e.classList.add(o) : 0))
					: attrs[k] !== ''
						? e.classList.add(attrs[k])
						: 0;
			} else if (k === 'style') {
				Object.keys(attrs[k]).forEach((ks) => {
					e.style[ks] = attrs[k][ks];
				});
			} else if (k === 'text') {
				attrs[k] === '' ? (e.innerHTML = '&nbsp;') : (e.innerText = attrs[k]);
			} else if (k === 'html') {
				attrs[k] === '' ? (e.innerHTML = '&nbsp;') : (e.innerHTML = attrs[k]);
			} else e[k] = attrs[k];
		});
	return e;
};

/**
 * Překreslení "labelu" v multiselectu
 * @param {HTMLDivElement} mainDiv
 */
const refresh = (mainDiv) => {
	mainDiv.querySelectorAll('span.optext').forEach((t) => mainDiv.removeChild(t));
	let el = mainDiv.previousSibling; // Originální select
	if (!(el instanceof HTMLSelectElement)) {
		throw new Error('Select before mainDiv not found');
	}
	let sels = Array.from(el.selectedOptions);
	let isMultiple = el.getAttribute('multiselect-multiple') === 'true';

	let label = el.attributes['multiselect-label']?.value;

	let somethingSelected = false;
	if (isMultiple) {
		if (sels.length > 0) {
			label += ' (' + sels.length + ')';
			somethingSelected = true;
		}
	} else {
		if (sels[0].value !== '-1') {
			label += ' (' + sels.length + ')';
			somethingSelected = true;
		}
	}

	mainDiv.prepend(
		newEl('span', {
			class: ['optext'],
			text: label
		})
	);

	if (somethingSelected) {
		mainDiv.classList.add('selectSelected');
	} else {
		mainDiv.classList.remove('selectSelected');
	}

	el.dispatchEvent(new Event('change')); // event po resetu hodnoty
};

/**
 *
 * @param {HTMLSelectElement} el
 * @return {HTMLSpanElement}
 */
const createClearButton = (mainDiv, list, parentCyValue) => {
	let el = mainDiv.previousSibling; // Originální select
	if (!(el instanceof HTMLSelectElement)) {
		throw new Error('Select before mainDiv not found');
	}
	let clearButton = newEl('span', { class: ['jpbtn', 'jpbtn-naked-primary', 'px-2'], text: 'zrušit výběr' });
	clearButton.setAttribute('data-clear-single-filter', '');
	// Nastavíme data-cy s předponou od rodiče
	clearButton.setAttribute('data-cy', parentCyValue + 'clear-single-filter');
	clearButton.setAttribute('tabindex', '0');
	clearButton.setAttribute('role', 'button');

	clearButton.addEventListener('click', () => {
		let isMultiple = el.getAttribute('multiselect-multiple') === 'true';

		let elements = list.querySelectorAll('div');
		Array.from(elements).map((element) => {
			element.checked = false;
			element.classList.checked = false;
			element.querySelector('input').checked = false;
			element.optEl.selected = false;
			if (element.optEl.getAttribute('disabled') === null) {
				element.style.display = '';
			}
		});

		if (!isMultiple) {
			// nastavení první hodnoty "nevybráno" v radiolistu
			elements[0].checked = true;
			elements[0].classList.checked = true;
			elements[0].querySelector('input').checked = true;
			elements[0].optEl.selected = true;
		}

		el.dispatchEvent(new Event('change')); // event po resetu hodnoty
		refresh(mainDiv); // refresh dropdownu
	});

	return clearButton;
};

/**
 *
 * @param {HTMLSelectElement} el
 * @returns {HTMLSpanElement}
 */
const createSearchButton = (el, parentCyValue) => {
	let searchButton = newEl('span', {
		class: ['jpbtn', 'jpbtn-primary'],
		text: el.getAttribute('multiselect-submit-label')
	});
	searchButton.setAttribute('data-cy', parentCyValue + 'search-single-filter');
	searchButton.setAttribute('tabindex', '0');
	searchButton.setAttribute('role', 'button');
	searchButton.addEventListener('click', () => {
		submitSearchForm(document.querySelector(el.getAttribute('multiselect-submit')));
	});

	return searchButton;
};

/**
 * Vytvoření obsahu dropdownu
 * @param {HTMLDivElement} mainDiv
 * @param {HTMLDivElement} list
 * @param {HTMLDivElement} listWrap
 */
const loadOptions = (mainDiv, list, listWrap) => {
	let el = mainDiv.previousSibling; // Originální select
	if (!(el instanceof HTMLSelectElement)) {
		throw new Error('Select before mainDiv not found');
	}
	list.innerHTML = '';

	let singleFilterButtons = newEl('div', { class: ['d-flex', 'justify-content-between', 'py-2', 'px-1'] });
	listWrap.appendChild(singleFilterButtons);

	// Najdeme nejbližšího rodiče s atributem data-cy
	let parentWithCy = el.closest('[data-cy]');
	let parentCyValue = parentWithCy ? parentWithCy.getAttribute('data-cy') + '-' : '';

	let clearButton = createClearButton(mainDiv, list, parentCyValue);
	singleFilterButtons.appendChild(clearButton);

	el.addEventListener('selectResetValue', function (e) {
		clearButton.dispatchEvent(new Event('click')); // reset dropdownu, pokud dojde k resetu zdrojového selectboxu
	});

	if (el.getAttribute('multiselect-submit')) {
		singleFilterButtons.appendChild(createSearchButton(el, parentCyValue));
	}

	// Vytvoření checkboxů a radiobuttonů
	Array.from(el.options).map((o) => {
		let isMultiple = el.getAttribute('multiselect-multiple') === 'true';
		let op = newEl('div', { class: 'form-check', optEl: o });
		let label = newEl('label', { class: 'form-check-label', html: o.text });
		op.appendChild(label);
		let input = null;

		if (isMultiple) {
			input = newEl('input', {
				type: 'checkbox',
				class: 'form-check-input',
				checked: o.selected
			});
		} else {
			input = newEl('input', {
				type: 'radio',
				class: 'form-check-input',
				name: el.attributes['id'].value + '_g',
				checked: o.selected
			});
		}

		// Nastavíme data-cy s předponou od rodiče
		input.setAttribute('data-cy', parentCyValue + el.attributes['id'].value + '-' + o.value);

		// reakce na změny ve zdrojovém selectboxu při aplikování omezení hodnot rewardFrom a rewardTo
		o.addEventListener('optionChangedAttribute', function (e) {
			if (e.target.getAttribute('disabled') !== null) {
				op.style.display = 'none'; // skrýt pokud je disabled
			} else {
				op.style.display = '';
			}
		});

		label.prepend(input);
		input.addEventListener('click', (ev) => {
			op.optEl.selected = input.checked;
		});
		o.listitemEl = op;
		list.appendChild(op);
	});
	mainDiv.listEl = listWrap;

	mainDiv.querySelectorAll('[role="button"]').forEach((el) => {
		roleButtonKeyboardControl(el);
	});

	refresh(mainDiv);
};

/**
 * Před odesláním musíme nastavit programově vytvořené inputy na disabled, aby nedošlo k jejich odeslání na server
 * V součastnosti jde o radiolist s name končící na _g
 * @param {HTMLFormElement} form
 */
const setDisabledCustomInputs = (form) => {
	form.addEventListener('submit', () => {
		form.querySelectorAll('[name$="_g"').forEach((input) => {
			input.disabled = true;
		});
	});
};

const initCustomSelect = function (element) {
	element.querySelectorAll('[data-multiselect]').forEach((el, k) => {
		if (el.form instanceof HTMLFormElement) {
			setDisabledCustomInputs(el.form);
		}

		let width = '235px';
		const dataCy = el.getAttribute('data-cy');

		// mainDiv je hlavní obalovací div pro dropdown s labelem a listem
		let mainDiv = newEl('div', {
			class: 'multiselect-dropdown'
		});

		mainDiv.setAttribute('tabindex', '0');
		mainDiv.setAttribute('role', 'button');
		mainDiv.setAttribute('aria-expanded', 'false');
		el.style.display = 'none';
		el.parentNode.insertBefore(mainDiv, el.nextSibling);
		roleButtonKeyboardControl(mainDiv);

		// listwrap je dropdown
		let listWrap = newEl('div', { class: 'multiselect-dropdown-list-wrapper' });
		listWrap.style.setProperty('min-width', width, 'important');
		listWrap.style.setProperty('display', 'none');

		// list je seznam checkboxů/radiobuttonů v dropdownu
		let list = newEl('div', { class: 'multiselect-dropdown-list' });
		listWrap.appendChild(list);
		mainDiv.appendChild(listWrap);

		if (dataCy) {
			el.closest('.filters-item').setAttribute('data-cy', dataCy + '-wrapper');
			list.setAttribute('data-cy', dataCy + '-list');
		}

		loadOptions(mainDiv, list, listWrap);

		// Otevření/zavření dropdownu po kliknutí
		mainDiv.addEventListener('click', function (event) {
			const target = event.target;
			if (target.matches('.optext')) {
				event.stopPropagation();

				// Pokud je otevřen, tak zavíráme a naopak
				let isOpen = mainDiv.listEl.style.display === 'block';
				mainDiv.listEl.style.display = isOpen ? 'none' : 'block';
				mainDiv.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
				if (isOpen) {
					mainDiv.classList.remove('open');
				} else {
					mainDiv.classList.add('open');
				}

				refresh(mainDiv);
			} else {
				mainDiv.listEl.style.display = 'block';
				mainDiv.setAttribute('aria-expanded', 'true');
				mainDiv.classList.add('open');
			}
		});

		// Zavření dropdownu po zmáčknutí ESC
		mainDiv.addEventListener('keydown', function (event) {
			if (event.key === 'Escape') {
				mainDiv.listEl.style.display = 'none';
				mainDiv.setAttribute('aria-expanded', 'false');
				mainDiv.classList.remove('open');
				mainDiv.focus();
			}
		});

		// Zavření dropdownu po přesunutí focus na jiný prvek
		mainDiv.addEventListener('focusout', function () {
			const nextFocused = event.relatedTarget;
			if (nextFocused && mainDiv.contains(nextFocused)) {
				return;
			}

			mainDiv.listEl.style.display = 'none';
			mainDiv.setAttribute('aria-expanded', 'false');
			mainDiv.classList.remove('open');
			refresh(mainDiv);
		});
	});
};

export default function () {
	initCustomSelect(document); // startujeme mimo init, protože pak dochází k většímu zpoždění

	$.nette.ext('customselect', {
		init: function () {
			this.ext('snippets', true).after(($el) => {
				if ($el.get(0)) {
					initCustomSelect($el.get(0));
				}
			});
		}
	});
}
